<template lang="pug">
  .b2b-filters-cierres-contables
    b2b-filters-component(
      :filter-options='filterOptions',
      :default-filter='filterOptions.name',
      @filters-query='filtersHaveChanged',
      @changeFilterDateTimePicker='dateRangeHaveChanged',
      :show-date-picker='true',
      :default-date-range='false',
      :initial-tags='initialTags',
      :initial-range='initialRange'
      )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bFiltersComponent from '@/components/B2bFiltersComponent'
import filters from './filtros-cierres-contables'

export default {
  name: 'b2b-filters-cierres-contables',
  data () {
    return {
      filterOptions: {},
      params: {},
      dateRange: [],
      defaultParams: {
        statusId: 2
      },
      initialTags: [],
      initialRange: []
    }
  },

  computed: {
    ...mapGetters([
      'getCierresContablesQueryParams',
      'optionsFilterService',
      'optionsFilterInvoiceReceiveBuyer',
      'optionsAccountingCloseStatus'
    ])
  },

  components: {
    B2bFiltersComponent
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'optionsServicesEnabledState',
      'searchOptionsAccountingCloseStatus'
    ]),
    filtersHaveChanged (params) {
      if (this.dateRange.length === 2) {
        params.closeDateTimeFrom = this.dateRange[0]
        params.closeDateTimeTo = this.dateRange[1]
      }

      this.params = params
      this.$emit('filters-changed', this.params)
    },

    dateRangeHaveChanged (dateRange) {
      if (dateRange == null || dateRange.length !== 2) {
        this.dateRange = []
        delete this.params.closeDateTimeFrom
        delete this.params.closeDateTimeTo
      } else {
        this.dateRange = dateRange
        this.params.closeDateTimeFrom = dateRange[0]
        this.params.closeDateTimeTo = dateRange[1]
      }
      this.$emit('filters-changed', this.params)
    },

    getQueryParams () {
      return JSON.parse(JSON.stringify(this.params))
    }
  },

  async created () {
    this.filterOptions = JSON.parse(JSON.stringify(filters.filters))

    // Cargar opciones
    if (this.optionsFilterService.length > 1) {
      const projectos = this.optionsFilterService
      this.filterOptions.projectId.options = []
      if (projectos) {
        for (const p of projectos) {
          this.filterOptions.projectId.options.push({ value: p.id, name: p.name })
        }
      }
    }

    const compradores = this.optionsFilterInvoiceReceiveBuyer
    this.filterOptions.buyerId.options = []
    if (compradores) {
      for (const c of compradores) {
        this.filterOptions.buyerId.options.push({ value: c.id, name: c.tradeName })
      }
    }

    this.searchOptionsAccountingCloseStatus()
    console.log('cogemos status')
    const status = this.optionsAccountingCloseStatus
    this.filterOptions.statusId.options = []
    console.log('status ', status)
    if (status) {
      for (const s of status) {
        const statusName = this.$t('status_accounting_close.' + s.code)
        this.filterOptions.statusId.options.push({ value: s.id, name: statusName })
      }
      console.log('this.filterOptions.statusId.options ', this.filterOptions.statusId.options)
    }

    // Traducir labels

    // Cargar valores almacenados
    let savedQueryParams = this.getCierresContablesQueryParams
    if (!savedQueryParams) {
      savedQueryParams = {}
    }
    this.params = { ...this.defaultParams, ...savedQueryParams }
    if (this.params.closeDateTimeFrom && this.params.closeDateTimeTo) {
      this.dateRange.push(savedQueryParams.closeDateTimeFrom)
      this.dateRange.push(savedQueryParams.closeDateTimeTo)
      this.initialRange.push(savedQueryParams.closeDateTimeFrom)
      this.initialRange.push(savedQueryParams.closeDateTimeTo)
    } else {
      delete this.params.closeDateTimeFrom
      delete this.params.closeDateTimeTo
    }
    this.initialTags = []
    for (const property in this.params) {
      if (property === 'closeDateTimeFrom' || property === 'closeDateTimeTo') {
        continue
      }
      const self = this
      const findFilter = function (filterName) {
        let filter = null
        // Comprobacion servicio
        if (self.optionsFilterService.length < 2) {
          delete self.filterOptions.projectId
        }
        for (const f in self.filterOptions) {
          if (self.filterOptions[f].prop === filterName) {
            filter = self.filterOptions[f]
            break
          }
        }
        return filter
      }
      let filterToAdd = findFilter(property)
      if (!filterToAdd) {
        let propertyName = ''
        if (property.endsWith('From')) {
          propertyName = property.substring(0, a.length - 4) // eslint-disable-line
        } else if (property.endsWith('To')) {
          propertyName = property.substring(0, a.length - 2) // eslint-disable-line
        }
        if (propertyName !== '') {
          filterToAdd = findFilter(propertyName)
        }
      }
      if (filterToAdd) {
        if (filterToAdd.componente === 'select') {
          const option = filterToAdd.options.find(
            x => x.value === this.params[filterToAdd.prop]
          )
          if (option) {
            filterToAdd.userValue = option.name
            filterToAdd.query = option.value
            this.initialTags.push(filterToAdd)
          }
        } else if (
          filterToAdd.componente === 'date' &&
          filterToAdd.tipo === 'daterange'
        ) {
          const tagFound = this.initialTags.find(
            t => t.prop === filterToAdd.prop
          )
          if (tagFound) {
            if (property.endsWith('From')) {
              tagFound.query[0] = this.params[filterToAdd.prop]
            } else {
              tagFound.query[1] = this.params[filterToAdd.prop]
            }
          } else {
            filterToAdd.query = [null, null]
            if (property.endsWith('From')) {
              filterToAdd.query[0] = this.params[filterToAdd.prop]
            } else {
              filterToAdd.query[1] = this.params[filterToAdd.prop]
            }
            this.initialTags.push(filterToAdd)
          }
        } else {
          filterToAdd.query = this.params[filterToAdd.prop]
          this.initialTags.push(filterToAdd)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}
::v-deep .b2b-search-bar__header-right {
  margin-right: 2.5rem;
}

</style>
